import Papa from "papaparse";
import * as XLSX from "xlsx";

/**
 * CSV dosyasını ayrıştırır
 * @param {string} fileData - Dosya içeriği
 * @returns {Promise<Array>} - Ayrıştırılmış veri
 */
export const parseCSV = (fileData) => {
  return new Promise((resolve, reject) => {
    Papa.parse(fileData, {
      worker: true,
      complete: (results) => {
        const data = results.data;
        if (data && data.length > 0) {
          // Tamamen boş satırları filtrele
          const filteredData = data.filter(row => !isRowEmpty(row));
          resolve(filteredData);
        } else {
          reject(new Error("Dosya boş veya geçersiz bir format içeriyor"));
        }
      },
      error: (error) => {
        console.error("CSV parse error:", error);
        reject(new Error("CSV dosyası okunurken bir hata oluştu"));
      },
    });
  });
};

/**
 * Bir satırın tamamen boş olup olmadığını kontrol eder
 * @param {Array} row - Satır verisi
 * @returns {boolean} - Satırın boş olup olmadığı
 */
const isRowEmpty = (row) => {
  if (!row || row.length === 0) return true;
  return row.every(cell => cell === null || cell === undefined || cell === "");
};

/**
 * XLSX dosyasını ayrıştırır
 * @param {string} fileData - Dosya içeriği
 * @returns {Array} - Ayrıştırılmış veri
 */
export const parseXLSX = (fileData) => {
  try {
    const workbook = XLSX.read(fileData, { type: "binary" });
    const firstSheetName = workbook.SheetNames[0];
    const worksheet = workbook.Sheets[firstSheetName];
    const rawData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
    
    // Tamamen boş satırları filtrele
    const filteredData = rawData.filter(row => !isRowEmpty(row));
    
    return filteredData;
  } catch (error) {
    console.error("XLSX parse error:", error);
    throw new Error("XLSX dosyası okunurken bir hata oluştu");
  }
};

/**
 * Dosyayı türüne göre ayrıştırır
 * @param {File} file - Yüklenen dosya
 * @param {Function} onSuccess - Başarı durumunda çağrılacak fonksiyon
 * @param {Function} onError - Hata durumunda çağrılacak fonksiyon
 */
export const parseFile = (file, onSuccess, onError) => {
  const reader = new FileReader();

  reader.onload = async (e) => {
    const fileData = e.target.result;
    const extension = file.name.split(".").pop()?.toLowerCase();

    try {
      let data;
      if (extension === "csv") {
        data = await parseCSV(fileData);
      } else if (extension === "xlsx" || extension === "xls") {
        data = parseXLSX(fileData);
      } else {
        throw new Error("Desteklenmeyen dosya formatı");
      }

      onSuccess(data);
    } catch (error) {
      onError(error);
    }
  };

  reader.onerror = () => {
    onError(new Error("Dosya okunurken bir hata oluştu"));
  };

  if (file.name.endsWith(".csv")) {
    reader.readAsText(file);
  } else {
    reader.readAsBinaryString(file);
  }
};
